<div class="key-value-editor">
  <div class="key-value-row" *ngFor="let row of rows; let i = index">
    <input type="text" [placeholder]="keyPlaceholder" [(ngModel)]="row.key" (change)="emitData()" />
    <select [(ngModel)]="row.valueType" (change)="emitData()">
      <option *ngFor="let valueType of valueTypes" [value]="valueType">{{valueType}}</option>
    </select>
    <input *ngIf="row.valueType !== 'null'" type="text" class="value-input"
      [placeholder]="row.valueType === 'json' ? 'JSON value' : 'value'"
      [(ngModel)]="row.value" (change)="emitData()" />
    <button class="button remove-button" (click)="removeRow(i)">Remove</button>
  </div>

  <button class="button" (click)="addRow()">Add Value</button>
</div>
